import PropTypes from 'prop-types'

export default PropTypes.shape({
  name: PropTypes.string.isRequired,
  suppliers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })).isRequired
})
